import { useAuth } from './useAuth';
import { Profile } from '../types';

const DEFAULT_PROFILE: Profile = {
  id: 'guest_init',
  full_name: 'Prospect',
  role: 'Athlete',
  sport: 'football',
  positions: ['Prospect'],
  grad_year: new Date().getFullYear() + 2,
  subscription_status: 'none',
  subscription_plan: 'none',
  social_handles: { twitter: '', instagram: '' },
  featured_stats: [],
};

export const useProfile = () => {
  const { profile, updateProfile, isGuest } = useAuth();

  const safeProfile = profile || DEFAULT_PROFILE;

  const isCoach = safeProfile.role === 'Coach';
  const isAD = safeProfile.role === 'AD';
  const isStaff = isCoach || isAD;
  const isSysAdmin = safeProfile.is_admin === true;

  return {
    profile: safeProfile,
    updateProfile,
    isCoach,
    isAD,
    isStaff,
    isSysAdmin,
    isGuest,
  };
};
